import api from "@/service/api";

const state = () => ({
    spotlight: null,
})

const mutations = {
    setSpotlight(state, value) {
        state.spotlight = value;
    },
}

const actions = {
    refresh({ commit }) {
        api.post('/spotlight/index').then((response) => {
            commit('setSpotlight', response?.data?.spotlight)
        });
    },
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}
